import dayjs from 'dayjs'
import type { HtmlHTMLAttributes } from 'react'

import { Card, CardContent } from '@/modules/shared/components/ui/card'
import { cn } from '@/modules/shared/lib/utils'

import type { ScheduleCard } from '../types/shedule-card.type'

type ScheduleCardProps = HtmlHTMLAttributes<HTMLDivElement> & {
  schedule: ScheduleCard
  scheduleSelected: ScheduleCard | undefined
  handleViewSchedule: (scheduleId: number) => void
  selectable?: boolean
}

export function ScheduleCardComponent({
  schedule,
  scheduleSelected,
  selectable = true,
  ...rest
}: ScheduleCardProps) {
  return (
    <Card className="flex flex-1 relative items-start cursor-pointer" {...rest}>
      <CardContent
        className={cn(
          'flex flex-1 w-full justify-between text-sm p-4 h-full ',
          selectable &&
            scheduleSelected?.idAgendamento === schedule.idAgendamento &&
            'bg-sky-200',
        )}
      >
        <div className="w-full">
          <div className="flex flex-1 justify-between items-s w-full">
            <h2 className="font-semibold  w-full text-sm">
              {schedule.cliente ?? 'EVENTO ANÔNIMO'}
            </h2>
            <div className="flex space-x-2">
              <p className="text-nowrap">
                {dayjs(schedule.data, {
                  locale: 'pt-br',
                }).format('DD/MM/YYYY [às] HH:mm')}
              </p>
            </div>
          </div>
          {schedule.cnpjcpf !== '..-' && <p>{schedule.cnpjcpf}</p>}
          {schedule.logradouro &&
            schedule.numero &&
            schedule.cidade &&
            schedule.uf && (
              <p className="flex items-center gap-2 text-xs">{`${schedule.logradouro} - ${schedule.numero}, ${schedule.cidade} - ${schedule.uf}`}</p>
            )}
          <p className="flex items-center gap-2 text-xs border-l-2 pl-2">{`${schedule.observacao}`}</p>
        </div>
      </CardContent>
    </Card>
  )
}
